import React, { useRef } from 'react';
import styles from './EclipseBackground.module.scss';
import { type EclipseProperties, EclipseRenderer } from './EclipseRenderer';

interface EclipseProps {
  count?: number;
}

export const EclipseBackground: React.FC<EclipseProps> = ({ count = 20 }) => {
  const eclipses = useRef<EclipseProperties[]>(EclipseRenderer.generateEclipses(count));

  return (
    <div className={styles.container}>
      {eclipses.current.map(eclipse => (
        <span
          key={eclipse.id}
          className={styles.eclipse}
          style={
            {
              width: eclipse.size,
              height: eclipse.size,
              left: `${eclipse.x}%`,
              top: `${eclipse.y}%`,
              opacity: eclipse.opacity,
              '--rotation': `${eclipse.rotation}deg`,
              '--delay': Math.random() * 5,
            } as React.CSSProperties
          }
        />
      ))}
    </div>
  );
};
